// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import store from './store'
import i18n from './i18n'

import Router from 'vue-router'
Vue.use(Router);

Vue.use(Vuex);


import ElementUI from 'element-ui';
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

import './styles/less/global.less'

import connect from '@/utils/connect'
Vue.prototype.$http=connect;

import util from '@/utils/util.js';
Vue.prototype.$cloneObj=util.cloneObj;
Vue.prototype.$loading = util.loading;

Vue.config.productionTip = false;

new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js